import { useEffect } from "react";

const Loading = () => {
  // reload page
  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload(false);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  //end reload page
  return (
    <div className="wrapper">
      <div className="loader">
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
      </div>
    </div>
  );
};

export default Loading;
